import { render, staticRenderFns } from "./WorkflowLavorazione.vue?vue&type=template&id=537d9c9b"
import script from "./WorkflowLavorazione.vue?vue&type=script&lang=ts"
export * from "./WorkflowLavorazione.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537d9c9b')) {
      api.createRecord('537d9c9b', component.options)
    } else {
      api.reload('537d9c9b', component.options)
    }
    module.hot.accept("./WorkflowLavorazione.vue?vue&type=template&id=537d9c9b", function () {
      api.rerender('537d9c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorkflowLavorazione.vue"
export default component.exports